<template>
    <div class="l-input" :class="{ 'l-input--prefix': this.$slots.prefix, 'l-input--suffix': this.$slots.suffix }">
        <div v-if="this.$slots.prefix" class="l-input__prefix">
            <slot name="prefix" />
        </div>
        <div v-if="this.$slots.suffix" class="l-input__suffix">
            <slot name="suffix" />
        </div>
        <!--<input class="l-input__inner" :name="name" :type="type" :value="value" :placeholder="placeholder" :disabled="disabled" :readonly="readonly" :max="max" :min="min" :autocomplete="[autocomplete ? 'off' : 'on']" @input="onInput" />-->
        <textarea class="l-input__inner" :placeholder="placeholder" :name="name" :disabled="disabled" :readonly="readonly" @input="onInput"  @change="onChange" :rows="rows">{{value}}</textarea>
    </div>
</template>

<script>
    export default {
        name: "LTextArea",
        model: {
            prop: "value",
            event: "input"
        },
        props: {
            value: [String],
            name: String,
            readonly: {
                type: Boolean,
                default: false
            },
            //autocomplete: {
            //    type: Boolean,
            //    default: false
            //},
            //min: Number,
            //max: Number,
            placeholder: String,
            disabled: {
                type: Boolean,
                default: false
            },
            rows: {
                type: Number,
                default: 3
            }
        },
        methods: {
            onInput(e) {
                this.$emit("input", e.target.value);
            },
            onChange(e) {
                this.$emit("change", e.target.value);
            }
        }
    };
</script>


<style lang="postcss">
    .l-input textarea.l-input__inner {
        height: inherit;
        padding-top: 0.25rem;
    }
</style>